import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const AboutUs = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}

          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">About Us</h5>
                <div className="row">
                  {/* <PopularServices /> */}

                  <div className="container my-4">
                    <div className="row">
                      <div class="about-content">
                        <h6>Who We Are</h6>
                        <p>
                          {APP_INFO.companyName} is a digital recharge and bill
                          payment platform owned and operated by CHOTTU TELECOM,
                          headquartered in West Bengal. We started with a vision
                          to simplify digital payments in semi-urban and rural
                          areas, making essential services like mobile recharges
                          and utility bill payments more accessible to everyone.
                          Since our launch, we’ve helped thousands of users
                          across Eastern India seamlessly manage their digital
                          transactions — quickly, securely, and affordably.
                        </p>

                        <h6>Our Vision</h6>
                        <p>
                          To become India’s most trusted digital platform that
                          empowers individuals and businesses with seamless
                          recharge, utility, and financial services, enabling
                          financial growth and digital inclusion for all.
                        </p>

                        <h6>Our Mission</h6>
                        <p>
                          At {APP_INFO.companyName} , our mission is to simplify
                          everyday transactions by offering fast, reliable, and
                          rewarding services such as mobile & DTH recharge, bill
                          payments, PAN services, insurance, and financial
                          products. We aim to empower our partners and users
                          with instant access, transparent commissions, and 24/7
                          support, driving sustainable growth and opportunities
                          across India.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AboutUs;
